var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M127.0664,23.8193c0,10.5898,0,98.0723,0,110.4336c-0.5117,0-91.7778,0-94.5474,0 c0-2.0166,0-123.7959,0-129.3418h75.8872v18.9082H127.0664z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M8.0591,105.7598c3.0249,0,5.5454,2.5205,5.5454,5.5449 c0,3.0254-2.5205,5.5459-5.5454,5.5459s-5.5454-2.5205-5.5454-5.5459C2.5137,108.2803,5.0342,105.7598,8.0591,105.7598z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFFFFF",
    d: "M140.4219,4.9111c4.0391,0,7.0645,3.2773,7.0645,7.0586 c0,4.0361-3.2793,7.0576-7.0645,7.0576c-4.0332,0-7.0586-3.2734-7.0586-7.0576C133.3633,8.1885,136.6445,4.9111,140.4219,4.9111z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.519,
    y: 91.6377,
    fillRule: "evenodd",
    fill: "#E0EDF9",
    width: 77.4009,
    height: 22.1885
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    fill: "#E0EDF9",
    points: "108.6563,133.9912 108.6563,144.833 21.6772,144.833 21.6772,20.543  32.519,20.543 32.519,91.6377 32.519,113.5771 32.519,133.9912  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#E0EDF9",
    d: "M108.6563,4.9111c5.8008,5.7979,12.8574,13.1113,18.6582,18.9082h-18.6582V4.9111z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M142.1895,23.8193c1.25,0,2.2715,1.0186,2.2715,2.2725 c0,1.25-1.0215,2.2646-2.2715,2.2646c-1.2559,0-2.2715-1.0146-2.2715-2.2646C139.918,24.8379,140.9336,23.8193,142.1895,23.8193z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M135.8848,80.5469c1.2578,0,2.2715,1.0146,2.2715,2.2715 c0,1.251-1.0137,2.2656-2.2715,2.2656c-1.25,0-2.2656-1.0146-2.2656-2.2656C133.6191,81.5615,134.6348,80.5469,135.8848,80.5469z "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M126.3066,142.0635c1.25,0,2.2715,1.0146,2.2715,2.2715 c0,1.251-1.0215,2.2656-2.2715,2.2656s-2.2715-1.0146-2.2715-2.2656C124.0352,143.0781,125.0566,142.0635,126.3066,142.0635z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M86.7227,104.752c0,0.4971,0,1.2568-0.2559,1.5117 c-1.5059,2.5205-6.0488,2.0166-8.3145,0.5039l1.0078-2.2715c0.7539,0.7529,5.041,2.2715,5.041,0.5039 c0-1.0078-2.2715-1.0078-4.0313-2.0166c-4.0332-2.0166-0.5059-8.8252,6.2969-4.792l-1.002,2.0166 c-0.5039-0.498-4.2871-2.0166-4.2871-0.249C80.9219,101.9756,86.7227,100.7188,86.7227,104.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M75.8804,103.4941c0.5044,1.002,0.2563,3.0254-1.0078,3.7783 c-2.0166,1.2637-5.5454,0.7529-7.562-0.5049l1.0083-2.2715c0.7529,0.7529,5.041,2.0234,5.041,0.5039 c0-1.0078-2.2651-1.0078-4.0327-2.0166c-4.0332-2.0166-0.5044-8.8252,6.3047-4.792l-1.0083,2.0166 c-0.2554-0.249-1.7676-1.002-3.0313-1.002c-1.5127,0-1.5127,1.002-1.2573,1.2637 C71.3433,101.4717,74.8726,101.4717,75.8804,103.4941z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M63.7817,104.2471l2.0161,1.2637c-0.7593,1.7617-2.7759,2.5146-4.5371,2.5146 c-5.5518,0-7.5684-8.0664-2.2715-10.5869c2.0161-1.002,5.2964-0.5039,6.5532,2.0166l-1.7607,1.2637 c-0.2554-0.7598-1.0083-1.2637-1.7681-1.5127c-4.5371-0.7598-4.7925,6.5537-0.7529,6.5537 C62.269,105.7598,63.2773,105.249,63.7817,104.2471z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M22.4302,4.9111c1.2568,0,2.2715,1.0156,2.2715,2.2686 c0,1.2539-1.0146,2.2725-2.2715,2.2725c-1.2505,0-2.2656-1.0186-2.2656-2.2725C20.1646,5.9268,21.1797,4.9111,22.4302,4.9111z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M14.3638,90.125c1.2573,0,2.272,1.0215,2.272,2.2725 c0,1.25-1.0146,2.2715-2.272,2.2715c-1.2505,0-2.2715-1.0215-2.2715-2.2715C12.0923,91.1465,13.1133,90.125,14.3638,90.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M8.0591,42.7305c1.2568,0,2.272,1.0156,2.272,2.2686 c0,1.2539-1.0151,2.2695-2.272,2.2695c-1.2505,0-2.2651-1.0156-2.2651-2.2695C5.7939,43.7461,6.8086,42.7305,8.0591,42.7305z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M108.6563,146.3516h-86.979c-0.7598,0-1.5127-0.7588-1.5127-1.5186V20.543 c0-0.7568,0.7529-1.5156,1.5127-1.5156h11.0908c0.7593,0,1.5122,0.7588,1.5122,1.5156c0,0.7559-0.7529,1.5117-1.5122,1.5117 h-9.5786v121.0166h83.9531v-9.0801c0-0.7529,0.7598-1.5059,1.5137-1.5059c0.7578,0,1.5117,0.7529,1.5117,1.5059v10.8418 C110.168,145.5928,109.4141,146.3516,108.6563,146.3516z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M127.0664,25.335h-18.6602c-0.7598,0-1.5117-0.7588-1.5117-1.5156V4.9111 c0-0.7559,0.752-1.5117,1.5117-1.5117c0.7539,0,1.5137,0.7559,1.5137,1.5117v17.3965h17.1465 c0.752,0,1.5117,0.7559,1.5117,1.5117C128.5781,24.5762,128.0742,25.335,127.0664,25.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M127.0664,135.7588H32.519c-0.7593,0-1.5122-0.7529-1.5122-1.5059v-20.4268 c0-0.7598,0.7529-1.5127,1.5122-1.5127c0.7529,0,1.5122,0.7529,1.5122,1.5127v18.9072h91.5156V24.3232 c-2.7695-2.7725-5.7949-6.0488-8.8262-9.0742c-3.0176-3.0244-6.0488-6.3047-8.8184-9.0771H34.2803v84.9619 c0,0.7588-0.7529,1.5186-1.5122,1.5186c-0.7529,0-1.5127-0.7598-1.5127-1.5186V4.9111c0-0.7559,0.7598-1.5117,1.5127-1.5117 h75.8882c0.5039,0,0.7578,0.252,1.0078,0.5039c3.0234,3.0244,6.0566,6.3047,9.3301,9.5781 c3.0234,3.2803,6.3047,6.5576,9.3281,9.3301c0.2559,0.252,0.5039,0.7559,0.5039,1.0078v110.4336 C128.8262,135.0059,128.0742,135.7588,127.0664,135.7588z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M8.0591,118.3691c-4.0332,0-7.0576-3.2861-7.0576-7.0645 c0-4.0322,3.2798-7.0576,7.0576-7.0576c4.0332,0,7.0645,3.2803,7.0645,7.0576C15.1235,115.083,12.0923,118.3691,8.0591,118.3691 L8.0591,118.3691z M8.0591,107.2725L8.0591,107.2725c-2.2651,0-4.0332,1.7607-4.0332,4.0322c0,2.2725,1.7681,4.04,4.0332,4.04 c2.272,0,4.0332-1.7676,4.0332-4.04C12.0923,109.0332,10.3311,107.2725,8.0591,107.2725z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M140.4219,20.543c-4.7852,0-8.5703-3.7813-8.5703-8.5732 c0-4.79,3.7852-8.5703,8.5703-8.5703c4.793,0,8.5762,3.7803,8.5762,8.5703C148.998,16.7617,145.2148,20.543,140.4219,20.543 L140.4219,20.543z M140.4219,6.4238L140.4219,6.4238c-3.0254,0-5.5449,2.5205-5.5449,5.5459 c0,3.0273,2.5195,5.5479,5.5449,5.5479s5.5527-2.5205,5.5527-5.5479C145.9746,8.9443,143.4473,6.4238,140.4219,6.4238z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M109.9199,115.083H32.519c-0.7593,0-1.5122-0.7529-1.5122-1.5059V91.3887 c0-0.7529,0.7529-1.5117,1.5122-1.5117h77.145c0.7598,0,1.5117,0.7588,1.5117,1.5117v22.1885 C111.4316,114.585,110.6719,115.083,109.9199,115.083L109.9199,115.083z M34.2803,112.0576L34.2803,112.0576h74.126V93.1504 h-74.126V112.0576z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,25.335h-4.7925c-0.7529,0-1.5127-0.7588-1.5127-1.5156 c0-0.7559,0.7598-1.5117,1.5127-1.5117h4.7925c0.7529,0,1.5122,0.7559,1.5122,1.5117 C52.9395,24.5762,52.4355,25.335,51.4272,25.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,33.1494h-4.7925c-0.7529,0-1.5127-0.7568-1.5127-1.5127 s0.7598-1.5127,1.5127-1.5127h4.7925c0.7529,0,1.5122,0.7568,1.5122,1.5127C53.1885,32.6455,52.4355,33.1494,51.4272,33.1494z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,41.2148h-4.7925c-0.7529,0-1.5127-0.7559-1.5127-1.5117 c0-0.7529,0.7598-1.5127,1.5127-1.5127h4.7925c0.7529,0,1.5122,0.7598,1.5122,1.5127 C53.1885,40.459,52.4355,41.2148,51.4272,41.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,49.0322h-4.7925c-0.7529,0-1.5127-0.7588-1.5127-1.5117 c0-0.7568,0.7598-1.5127,1.5127-1.5127h4.7925c0.7529,0,1.5122,0.7559,1.5122,1.5127 C53.1885,48.2734,52.4355,49.0322,51.4272,49.0322z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,56.8467h-4.7925c-0.7529,0-1.5127-0.7568-1.5127-1.5127 s0.7598-1.5127,1.5127-1.5127h4.7925c0.7529,0,1.5122,0.7568,1.5122,1.5127C53.1885,56.0898,52.4355,56.8467,51.4272,56.8467z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,64.6641h-4.7925c-0.7529,0-1.5127-0.7568-1.5127-1.5127 s0.7598-1.5127,1.5127-1.5127h4.7925c0.7529,0,1.5122,0.7568,1.5122,1.5127C53.1885,64.1592,52.4355,64.6641,51.4272,64.6641z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,72.7295h-4.7925c-0.7529,0-1.5127-0.7529-1.5127-1.5088 s0.7598-1.5156,1.5127-1.5156h4.7925c0.7529,0,1.5122,0.7598,1.5122,1.5156C53.1885,71.9766,52.4355,72.7295,51.4272,72.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M51.4272,80.5469h-4.7925c-0.7529,0-1.5127-0.7529-1.5127-1.5127 c0-0.7588,0.7598-1.5117,1.5127-1.5117h4.7925c0.7529,0,1.5122,0.7529,1.5122,1.5117 C52.9395,79.7939,52.4355,80.5469,51.4272,80.5469z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M65.7979,25.335H57.981c-0.7598,0-1.5127-0.7588-1.5127-1.5156 c0-0.7559,0.7529-1.5117,1.5127-1.5117h7.8169c0.7529,0,1.5127,0.7559,1.5127,1.5117 C67.3105,24.5762,66.5508,25.335,65.7979,25.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M82.9375,25.335H70.335c-0.7593,0-1.5122-0.7588-1.5122-1.5156 c0-0.7559,0.7529-1.5117,1.5122-1.5117h12.6025c0.7598,0,1.5137,0.7559,1.5137,1.5117 C84.4512,24.5762,83.9473,25.335,82.9375,25.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M72.0962,33.1494H57.981c-0.7598,0-1.5127-0.7568-1.5127-1.5127 s0.7529-1.5127,1.5127-1.5127h14.1152c0.7598,0,1.519,0.7568,1.519,1.5127C73.6152,32.6455,72.856,33.1494,72.0962,33.1494z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M81.4258,33.1494h-3.2734c-0.7598,0-1.5117-0.7568-1.5117-1.5127 s0.752-1.5127,1.5117-1.5127h3.2734c0.7598,0,1.5117,0.7568,1.5117,1.5127C82.9375,32.6455,82.1855,33.1494,81.4258,33.1494z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M91.0117,33.1494h-4.793c-0.7539,0-1.5117-0.7568-1.5117-1.5127 s0.7578-1.5127,1.5117-1.5127h4.793c0.752,0,1.5117,0.7568,1.5117,1.5127C92.5234,32.6455,91.7637,33.1494,91.0117,33.1494z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M62.5181,41.2148h-4.7861c-0.7593,0-1.519-0.7559-1.519-1.5117 c0-0.7529,0.7598-1.5127,1.519-1.5127h4.7861c0.7593,0,1.5122,0.7598,1.5122,1.5127 C64.0303,40.459,63.2773,41.2148,62.5181,41.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M79.9141,41.2148H68.8228c-0.7593,0-1.5122-0.7559-1.5122-1.5117 c0-0.7529,0.7529-1.5127,1.5122-1.5127h11.0913c0.7598,0,1.5117,0.7598,1.5117,1.5127 C81.4258,40.459,80.6738,41.2148,79.9141,41.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M64.0303,49.0322h-6.2983c-0.7593,0-1.519-0.7588-1.519-1.5117 c0-0.7568,0.7598-1.5127,1.519-1.5127h6.2983c0.7593,0,1.5122,0.7559,1.5122,1.5127 C65.7979,48.2734,65.0386,49.0322,64.0303,49.0322z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M84.707,49.0322H70.584c-0.7529,0-1.5122-0.7588-1.5122-1.5117 c0-0.7568,0.7593-1.5127,1.5122-1.5127h14.123c0.7578,0,1.5117,0.7559,1.5117,1.5127 C86.2188,48.2734,85.4648,49.0322,84.707,49.0322z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M65.7979,56.8467H57.981c-0.7598,0-1.5127-0.7568-1.5127-1.5127 s0.7529-1.5127,1.5127-1.5127h7.8169c0.7529,0,1.5127,0.7568,1.5127,1.5127S66.5508,56.8467,65.7979,56.8467z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M94.0352,56.8467H71.8477c-0.7529,0-1.5127-0.7568-1.5127-1.5127 s0.7598-1.5127,1.5127-1.5127h22.1875c0.7539,0,1.5137,0.7568,1.5137,1.5127S94.7891,56.8467,94.0352,56.8467z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M72.0962,64.6641H57.981c-0.7598,0-1.5127-0.7568-1.5127-1.5127 s0.7529-1.5127,1.5127-1.5127h14.1152c0.7598,0,1.519,0.7568,1.519,1.5127C73.6152,64.1592,72.856,64.6641,72.0962,64.6641z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M81.4258,64.6641h-3.2734c-0.7598,0-1.5117-0.7568-1.5117-1.5127 s0.752-1.5127,1.5117-1.5127h3.2734c0.7598,0,1.5117,0.7568,1.5117,1.5127C82.9375,64.1592,82.1855,64.6641,81.4258,64.6641z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M92.5234,64.6641h-4.793c-0.752,0-1.5117-0.7568-1.5117-1.5127 s0.7598-1.5127,1.5117-1.5127h4.793c0.752,0,1.5117,0.7568,1.5117,1.5127C94.0352,64.1592,93.2754,64.6641,92.5234,64.6641z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M62.5181,72.7295h-4.7861c-0.7593,0-1.519-0.7529-1.519-1.5088 s0.7598-1.5156,1.519-1.5156h4.7861c0.7593,0,1.5122,0.7598,1.5122,1.5156S63.2773,72.7295,62.5181,72.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M79.9141,72.7295H68.8228c-0.7593,0-1.5122-0.7529-1.5122-1.5088 s0.7529-1.5156,1.5122-1.5156h11.0913c0.7598,0,1.5117,0.7598,1.5117,1.5156S80.6738,72.7295,79.9141,72.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M92.5234,72.7295h-6.3047c-0.7539,0-1.5117-0.7529-1.5117-1.5088 s0.7578-1.5156,1.5117-1.5156h6.3047c0.752,0,1.5117,0.7598,1.5117,1.5156S93.2754,72.7295,92.5234,72.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M64.0303,80.5469h-6.2983c-0.7593,0-1.519-0.7529-1.519-1.5127 c0-0.7588,0.7598-1.5117,1.519-1.5117h6.2983c0.7593,0,1.5122,0.7529,1.5122,1.5117 C65.5425,79.7939,65.0386,80.5469,64.0303,80.5469z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#BAD7F0",
    d: "M84.707,80.5469H70.584c-0.7529,0-1.5122-0.7529-1.5122-1.5127 c0-0.7588,0.7593-1.5117,1.5122-1.5117h14.123c0.7578,0,1.5117,0.7529,1.5117,1.5117 C86.2188,79.7939,85.4648,80.5469,84.707,80.5469z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoIcon4);
export default __webpack_public_path__ + "static/media/who-icon-4.fef855f3e18798f1a0ee70400bd29563.svg";
export { ForwardRef as ReactComponent };